module.exports = __webpack_public_path__ + "static/media/wed-2.66c749ec.jpg";